import { render, staticRenderFns } from "./InspectorTailwindCss.vue?vue&type=template&id=b4874a24&"
import script from "./InspectorTailwindCss.vue?vue&type=script&lang=js&"
export * from "./InspectorTailwindCss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports